import { Form } from "antd";
import styled from "styled-components";

export const FormItemNoMargin = styled(Form.Item)`
  margin: 0px;
`;
